import React, { Component } from "react";
import PropTypes from "prop-types";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import Str from "shared/components/Str";
import OkInput from "shared/components/oknf/OkInput";

import { VALIDATION_TIMEOUT } from "apps/signup/util/constants";

let passwordValidationTimeout = null;

class Password extends Component {
	static propTypes = {
		fieldName: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		onChange: PropTypes.func.isRequired,
		validate: PropTypes.func.isRequired,
		hasError: PropTypes.bool,
		feedback: PropTypes.string,
		success: PropTypes.bool,
		setCaptchaV3Token: PropTypes.func.isRequired,
	};

	static defaultProps = {
		hasError: false,
		feedback: "",
		success: false,
	}

	_triggerValidation = (field, value) => {
		clearTimeout(passwordValidationTimeout);
		passwordValidationTimeout = setTimeout(() => {
			this.props.validate(field, value);
		}, VALIDATION_TIMEOUT);
	}

	_onChange = (ev) => {
		const { value } = ev.target;

		this.props.onChange(this.props.fieldName, ev.target.value);
		this._triggerValidation(this.props.fieldName, value);
	}

	_onBlur = () => {
		if (!this.props.success) {
			this.props.validate(this.props.fieldName, this.props.value);
		}
	}

	render() {
		const {
			hasError,
			feedback,
			setCaptchaV3Token,
		} = this.props;

		return (
			<div className="signup2017-password">
				<span className="signup2017-field-label">
					<Str>Password</Str>
				</span>

				<OkInput
					ref={(div) => { this.password = div; }}
					name="password"
					type="password"
					autoComplete="off"
					placeholder="6 characters minimum"
					value={this.props.value}
					className="signup2017-input"
					onChange={this._onChange}
					onBlur={this._onBlur}
					error={hasError ? feedback : false}
					success={hasError ? false : feedback}
				/>
				<GoogleReCaptcha onVerify={setCaptchaV3Token} />
			</div>
		);
	}
}

export default Password;



// WEBPACK FOOTER //
// ./src/apps/signup/components/Registration/Password.jsx